import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tenantFromHostname } from './tenant-from-host'; 

@Injectable({
  providedIn: "root"
})
export class HttpSmilegoInterceptor implements HttpInterceptor {

  notInterceptableEndpointList: RegExp[] = [
    new RegExp(/app\/ngsw.json/ig)
  , new RegExp(/config.yml/ig)
  , new RegExp(/config-productId-\d.yml/ig) 
  , new RegExp(/style-productId-\d.css/ig) 
  , new RegExp(/style.css/ig) 
];

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let urlResource = request.url;
    
    if(this.notInterceptableEndpointList.some(ep => ep.test(urlResource))){
      return next.handle(request);
    }

    let tenant = tenantFromHostname(window.location.hostname);

    // baseUrl = `https://${tenant}-service.onboarding.smilego.io/api`;

    const httpsReq = request.clone({
      // url: `${baseUrl}${urlResource}`,
      withCredentials: false,
      setHeaders: {"X-TENANT-ID": tenant}
    });

    return next.handle(httpsReq);
  }

}
